module.exports = __webpack_public_path__ + "img/symbol_s12.e2b9947.svg";